<template>
  <div>
    <div v-if="isShowDay" :class="$style.day">
      <span :class="$style.dayDate">{{ date }}</span>
    </div>
    <div
      v-if="!message.deleted"
      :class="[
        $style.container,
        'gl-message-container'
      ]"
    >
      <div :class="$style.avatarContainer">
        <Avatar :size="40" :user="user" @click.native="showProfile" />
      </div>
      <div :class="$style.messageContainer">
        <div :class="$style.name">
          <span @click="showProfile" :style="nameStyle">{{ name }}</span>
        </div>
        <!-- <div
          v-if="message.payload.mediaType === 'IMAGE'"
          :class="$style.imgWrap"
          @click.stop
        ></div> -->
        <img
          v-if="message.payload.mediaType === 'IMAGE'"
          v-lazy="message.payload.mediaLink"
          :alt="message.payload.title"
          :class="$style.img"
          v-viewer
        >
        <video
          v-else-if="message.payload.mediaType === 'VIDEO'"
          :src="message.attachment.mediaLink"
          preload="metadata"
        ></video>
        <!-- <div
          v-else-if="message.payload.mediaType === 'VIDEO'"
          @click.stop
        ></div> -->
        <div :class="$style.title">{{ message.payload.title }}</div>
        <div>
          {{ message.payload.statusText }}
        </div>
      </div>
      <div :class="$style.sideInfo">
        <div>
          <span :class="$style.time">{{ time }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'
import { format } from '@/utils/date'
import { getUserDisplayName, getColorById } from '@/utils/helpers'
import { startOfDay } from 'date-fns'

export default {
  name: 'mood-message',
  components: {
    Avatar
  },
  props: {
    message: Object,
    firstMessagesByDay: Object
  },
  computed: {
    user () {
      return this.$store.getters['entities/users/find'](this.message.senderId)
    },
    name () {
      if (!this.user) return
      return getUserDisplayName(this.user)
    },
    colors () {
      if (!this.user) return
      return getColorById(this.user.userId)
    },
    nameStyle () {
      if (!this.colors) return
      return `color: ${this.colors[0]}`
    },
    time () {
      return format(new Date(this.message.created + 'Z'), 'HH:mm')
    },
    date () {
      return format(new Date(this.message.created + 'Z'), 'd MMMM')
    },
    isMy () {
      return this.message.senderId === this.$store.state.auth.user.id
    },
    isShowDay () {
      const dayBeginTimestamp = startOfDay(new Date(this.message.createdTs)) * 1
      const firstMessage = this.firstMessagesByDay[dayBeginTimestamp]
      if (!firstMessage) return false
      return firstMessage.messageId === this.message.messageId
    }
  },
  methods: {
    showProfile () {
      this.$modal.show('profile', {
        userId: this.user.userId
      })
    }
  }
}
</script>

<style module lang="scss">
.day {
  text-align: center;
  margin: 24px 0 12px;
  color: $text-lightest;
  &Date {
    background-color: rgba($main-bg-colored, 0.45);
    padding: 6px 15px;
    border-radius: 15px;
  }
}
.container {
  display: flex;
  padding: 8px 50px;
  cursor: pointer;
  position: relative;
}
.avatarContainer {
  // padding-top: 12px;
  padding-right: 14px;
  flex-shrink: 0;
  width: 54px;
}
.messageContainer {
  flex-grow: 1;
  overflow: hidden;
}
.sideInfo {
  flex-shrink: 0;
  color: $text-light;
  font-size: 12px;
  text-transform: lowercase;
}
.name {
  font-weight: 500;
  color: $text-colored;
  margin-bottom: 6px;
}
.time {
  display: inline-block;
  min-width: 35px;
  text-align: right;
}
.img {
  max-width: 80%;
  max-height: 300px;
  object-fit: contain;
}
.title {
  font-weight: 500;
  margin-top: 8px;
}
.text {
  margin-top: 2px;
}
</style>
